<template>
  <div class="user-profile-card">
    <div v-if="userDataLoader" class="group-data-loader">
      <spinner/>
    </div>
    <div v-else-if="!userData">
      <error-alert
        message="Не удалось загрузить данные профиля."
      />
      <div>
        <a href="/login" class="link">войти или зарегистрироваться</a>
      </div>
    </div>
    <div v-else>
      
      <!-- <div class="user-avatar">
        <avatar-uploader 
          :max-size-mb="5"
          :min-width="150"
          :min-height="150"
          :size="100"
        />
      </div> -->
      <div class="group-box" :class="{'compact': !$store.state.onMobile}">
        <div class="qrcode-btn-container">
          <!-- Кнопка с иконкой для показа QR-кода -->
          <button class="qr-btn" @click="showQrCodeClick" title="Показать QR-код">
            <img src="@/assets/icons/qr-icon.svg" alt="QR" />
          </button>
        </div>
        <div class="avatar-container">
          <AvatarCircle
            :size="200"
            :username="userData.fullName"
            :readonly="userDataLoader"
            :src="userData.avatarUrl && userData.avatarUrl.length ? $host.host + userData.avatarUrl: null"
            @click="isAvatarUploadModalOpen = true" />
        </div>
        <span class="group-box-header">Персональные данные</span>
        <!-- <span class="group-box-header">Статус: {{$store.state.userRoleName}}</span> -->
        <hr>
        <!-- <DatePickerBox
          type="datetime"
          prefix="Дата регистрации"
          :value="userData.createdDateTime | formatDateTime"
          showSeparator
          readonly
          :prefixColor="linkTextColor"
        /> -->
        <text-box
          prefix=""
          :value="userData.fullName"
          showSeparator
          readonly
          :prefixColor="linkTextColor"
        />
        <text-box
          prefix="@"
          :value="userData.email"
          showSeparator
          readonly
          :prefixColor="linkTextColor"
        />
        <text-box
          prefix="Зарегистрирован"
          :value="userData.createdDateTime | formatDateOnlyOffset"
          showSeparator
          readonly
          :prefixColor="linkTextColor"
        />
        <DatePickerBox
          type="date"
          prefix="Дата рождения"
          :value="userData.dateOfBirth"
          showSeparator
          readonly
          :prefixColor="linkTextColor"
        />
        <div v-if="userData.avatarUrl && userData.avatarUrl.length">
          <button @click="deleteAvatarClick" class="link passive align-left">удалить аватарку</button>
        </div>
      </div>      
      <div class="group-box" :class="{'compact': !$store.state.onMobile}" v-if="!userData.isAdminEmployee">
        <span class="group-box-header">Статус: {{userData.role.name}}<br><span class="group-box-header_sub">(на стадии обсуждения)</span></span>
        <hr>
        <div v-if="userData.roleType === roleType_user" class="vertical-buttons">
          <button class="link">Я являюсь студентом (Todo)</button>
          <button class="link">Я являюсь преподавателем (Todo)</button>
        </div>
        <div v-else-if="userData.roleType === roleType_student">
          Todo: поля возможности для роли учащегося
        </div>
        <div v-else-if="userData.roleType === roleType_teacher">
          Todo: поля возможности для роли преподавателя
        </div>
      </div>
      <div class="group-box" :class="{'compact': !$store.state.onMobile}">
        <span class="group-box-header">Приватность<br><span class="group-box-header_sub">(на стадии обсуждения)</span></span>
        <hr>
        <toggle
          text="2FA (рекомендуется)"
          v-model="userData.userPrivacy.twoFactAuthEnabled"
          :disabled="true"
          @change="updatePrivacySettingClick"
          description="Вход с кодом подтверждения из email"
        />
        <toggle
          text="Получать приглашения"
          v-model="userData.userPrivacy.allowEventInvitations"
          @change="updatePrivacySettingClick"
          description="Разрешить приглашать Вас на события"
        />
        <toggle
          text="Разрешить запросы дружбы"
          v-model="userData.userPrivacy.allowFriendshipRequest"
          @change="updatePrivacySettingClick"
          description="Разрешить другим пользователям отправлять вам заявку на дружбу"
        />
        <DropDownBox
          prefix="Видимость персональных данных"
          :noWrapPrefix="$store.state.onMobile === false"
          :disabled="userProfileVisibilityTypesLoader"
          title="Видимость персональных данных"
          placeholder="не выбрано"
          :showSeparator="true"
          :options="userProfileVisibilityTypes"
          :show-radio="$store.state.onMobile"
          :hide-scrollbar="$store.state.onMobile"
          field-key="key"
          field-value="value"
          @input="updatePrivacySettingClick"
          v-model="userData.userPrivacy.userProfileVisibility"
        />
        <DropDownBox
          prefix="Видимость даты рождения"
          :noWrapPrefix="$store.state.onMobile === false"
          :disabled="dateOfBirthVisibilityTypesLoader"
          title="Видимость даты рождения"
          placeholder="не выбрано"
          :showSeparator="true"
          :options="dateOfBirthVisibilityTypes"
          :show-radio="$store.state.onMobile"
          :hide-scrollbar="$store.state.onMobile"
          field-key="key"
          field-value="value"
          @input="updatePrivacySettingClick"
          v-model="userData.userPrivacy.dateOfBirthVisibility"
        />
      </div>
      <div class="group-box" :class="{'compact': !$store.state.onMobile}">
        <span class="group-box-header">Уведомления<br><span class="group-box-header_sub">(на стадии обсуждения)</span></span>
        <hr>
        <toggle
          text="Включить Push уведомления"
          v-model="userData.notificationSetting.pushEnabled"
          @change="updateNotificationSettingClick"
        />
        <toggle
          text="Запросы дружбы"
          v-model="userData.notificationSetting.friendshipRequests"
          @change="updateNotificationSettingClick"
        />
        <toggle
          text="Новости и события по интересам"
          v-model="userData.notificationSetting.eventInvitations"
          @change="updateNotificationSettingClick"
        />
      </div>
      <div class="group-box" :class="{'compact': !$store.state.onMobile}" v-if="!hideUserInterests">
        <span class="group-box-header">Интересы</span>
        <hr>
        <span class="group-box-header_sub">(на стадии обсуждения)</span>
        <!-- <div v-if="userTagsLoader || tagsLoader" class="group-data-loader">
          <spinner/>
        </div>
        <error-alert
          v-else-if="!tags || !userTags || !userTags.enabledTags"
          message="Не удалось загрузить список интересов"
        />
        <multiselect
          v-else
          :disabled="userTagsSaveLoader"
          :options="tags"
          :searchKeys="['value']"
          fieldKey="id"
          fieldValue="name"
          placeholder="не задано"
          v-model="userTags.enabledTags"
        />
        <button
          class="btn blue align-left"
          v-show="userTagsChanged"
          :disabled="userTagsSaveLoader"
          @click="updateUserTags">Сохранить</button> -->
      </div>

      <div class="group-box" :class="{'compact': !$store.state.onMobile}">
        <span class="group-box-header">Оформление</span>
        <hr>
        <VisualAppearanceOptions />
      </div>
      <!-- <div class="group-box" :class="{'compact': !$store.state.onMobile}">
        <span class="group-box-header">Пароль</span>
        <hr>
        <change-password-box/>
      </div> -->
      <div class="group-box" :class="{'compact': !$store.state.onMobile}">
        <span class="group-box-header">Настройки локации</span>
        <hr>
        <toggle
          text="Определять мое местоположение автоматически"
          v-model="shareLocation"
          @change="toggleLocation"
          :description="showInstructions ? 'Скрыть инструкцию' : 'Как разрешить доступ?'"
          :descriptionClickable="true"
          @descriptionClick="showInstructions = !showInstructions"
        />
        <error-alert v-if="watchLocationErrorMessage" 
          :message="watchLocationErrorMessage"
        />
        <div v-if="showInstructions" class="instructions-steps">
          <h4>Инструкция для Chrome / Яндекс.Браузера:</h4>
          <ol>
            <li>Кликните на иконку настроек (замочек/ползунки) слева от адреса сайта <b>в самой верхней строке браузера</b>.</li>
            <li>В пункте <b>«Геолокация»</b> выберите <b>«Разрешить»</b>.</li>
            <li>Перезагрузите эту страницу.</li>
          </ol>
          
          <h4>Инструкция для iPhone (Safari):</h4>
          <ol>
            <li>Зайдите в настройки телефона → <i>Конфиденциальность</i> → <i>Службы геолокации</i>.</li>
            <li>В списке найдите <i>«Сайты Safari»</i> и выберите <i>«При использовании»</i>.</li>
          </ol>
          <div class="item-state-description">
            <sub>* инструкция является приблизительной, т.к. в различных устройствах и моделях наименования и расположение параметров может отличаться</sub>
          </div>
        </div>
        <!-- Блок успешного статуса -->
        <div v-else-if="shareLocation && latitude" class="location-info-block">
          <p class="success-text">● Геолокация активна</p>
          <sub v-if="isDevelopmentMode">(эмуляция для демонстрации)</sub>
          <div class="coordinates-display">
            <p><b>Широта (Latitude):</b> {{ latitude.toFixed(6) }}</p>
            <p><b>Долгота (Longitude):</b> {{ longitude.longitude ? longitude.longitude.toFixed(6) : (longitude && longitude.toFixed ? longitude.toFixed(6) : longitude) }}</p>
          </div>
          <p>Точность: {{ isPrecise ? 'Высокая (GPS)' : 'Приблизительная' }}</p>
        </div>
      </div>
      <div class="group-box" :class="{'compact': !$store.state.onMobile}">
        <span class="group-box-header">Учётная запись</span>
        <hr>
        <div class="vertical-buttons">
          <button :disabled="true" class="link">Выйти со всех устройств</button>
          <button class="link" @click="showChangePasswordDlg">Изменить пароль</button>
          <button :disabled="true" class="link">Настроить контрольные вопросы</button>
          <button :disabled="true" class="link passive-red">Удалить учётную запись</button>
        </div>
      </div>
      <div class="group-box" :class="{'compact': !$store.state.onMobile}">
        <HwidCard/>
      </div>
    </div>
    <confirm-dialogue :theme="$store.state.theme" ref="confirmationDialogue"/>
    <!-- Наше модальное окно -->
    <AvatarUploadModal 
      v-model="isAvatarUploadModalOpen" 
      @save="updateAvatar"
    />
    <action-dialogue :theme="$store.state.theme" :size="!$store.state.onMobile ? 'small' : ''" ref="qrCodeDialogue">
      <template v-slot:content>
         <!-- Компонент генерации QR-кода -->
        <div class="qr-container" v-if="userData && userData.id">
          <!-- Обертка, которая управляет смешиванием цветов -->
          <div class="qr-gradient-wrapper" :style="{ width: qrCodeSize + 'px', height: qrCodeSize + 'px' }">
            <qrcode-vue 
              :value="qrValue"
              :size="qrCodeSize"
              level="Q"
              background="transparent" 
              foreground="#000000"
            />
            <!-- 2. Градиентный слой, который окрасит черные пиксели -->
            <div class="gradient-overlay"></div>
          </div>
        </div>
        <p class="qr-code-hint_label">Покажите этот QR код тому,<br>с кем хотите подружиться</p>
      </template>
    </action-dialogue>
    <action-dialogue :theme="$store.state.theme" :size="!$store.state.onMobile ? 'small' : ''" ref="changePasswordDialogue">
      <template v-slot:content>
        <change-password-box @success="closeChangePasswordDialogue"/>
      </template>
    </action-dialogue>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import QrcodeVue from 'qrcode.vue';
import VisualAppearanceOptions from '@/components/VisualAppearanceOptions.vue';
import ActionDialogue from '@/components/ActionDialogue.vue';
import ConfirmDialogue from '@/components/ConfirmDialogue.vue';
import ChangePasswordBox from '@/components/Users/ChangePasswordBox.vue';
import AvatarUploader from '@/components/Users/AvatarUploader.vue';
import AvatarUploadModal from '@/components/AvatarUploadModal.vue';
import HwidCard from './HwidCard.vue';
import Toggle from '../Toggle.vue';

export default {
  name: "UserProfileCard",
  components: {
    ActionDialogue,
    ConfirmDialogue,
    VisualAppearanceOptions,
    ChangePasswordBox,
    AvatarUploader,
    AvatarUploadModal,
    QrcodeVue,
    HwidCard,
    Toggle
  },
  data: function () {
    return {
      roleType_user: 1,
      roleType_student: 4,
      roleType_teacher: 5,
      hideUserInterests: true,
      userDataLoader: true,
      userData: null,
      userProfileVisibilityTypes: [],
      userProfileVisibilityTypesLoader: true,
      dateOfBirthVisibilityTypes: [],
      dateOfBirthVisibilityTypesLoader: true,

      // tagsLoader: true,
      // tags: [
      //   { id: '1', name: 'спорт' },
      //   { id: '2', name: 'шахматы' },
      //   { id: '3', name: 'театр' },
      //   { id: '4', name: 'наука' },
      // ],
      // userTagsLoader: true,
      // userTags: null,
      // userTagsChanged: false,
      // userTagsSaveLoader: false,

      isAvatarUploadModalOpen: false,
      qrCodeSize: 200,

      watchLocationErrorMessage: null,
      showInstructions: false
    }
  },
  computed: {
    linkTextColor() {
      // Получаем значение --linkTextColor из :root или конкретного элемента
      const rootStyles = getComputedStyle(document.documentElement);
      return rootStyles.getPropertyValue('--linkTextColor').trim();
    },
    qrValue() {
      return `${this.$host.BaseAddress}/friends?show-user-id=${this.userData.id}`;
    },
    // Синхронизируем состояние с Vuex, чтобы чекбокс не сбрасывался при перезагрузке
    shareLocation: {
      get() {
        return this.$store.state.location.isEnabled;
      },
      set(value) {
        this.$store.commit('location/SET_ENABLED', value);
      }
    },
    ...mapState('location', ['isEnabled', 'latitude', 'longitude', 'isPrecise', 'accuracy']),
    isDevelopmentMode() {
      // Возвращает true, если сайт запущен локально (http или localhost)
      return window.location.protocol !== 'https:' || window.location.hostname === 'localhost';
    }
  },
  methods: {
    ...mapActions('location', ['enableTracking', 'disableTracking']),
    async toggleLocation(checked) {
      this.watchLocationErrorMessage = null; // Сбрасываем прошлую ошибку перед запуском

      if (checked) {
        try {
          // Ждем активации трекера
          await this.enableTracking();
        } catch (error) {
          // Обрабатываем конкретные коды ошибок браузера
          switch (error.code) {
            case 1: // PERMISSION_DENIED
              // Проверяем, не запущен ли сайт без HTTPS на внешнем сервере
              if (window.location.protocol !== 'https:' && window.location.hostname !== 'localhost') {
                this.watchLocationErrorMessage = 'Браузер блокирует геолокацию, так как сайт работает без HTTPS (незащищенное соединение). Обратитесь к администратору сайта.';
              } else {
                this.watchLocationErrorMessage = 'Вы заблокировали доступ к геолокации. Пожалуйста, разрешите её в настройках браузера или операционной системы.';
              }
              break;
            case 2: // POSITION_UNAVAILABLE
              this.watchLocationErrorMessage = 'Не удалось определить местоположение. Проверьте сигнал GPS или сети.';
              break;
            case 3: // TIMEOUT
              this.watchLocationErrorMessage = 'Время ожидания запроса истекло. Попробуйте еще раз.';
              break;
            default:
              this.watchLocationErrorMessage = error.message || 'Произошла неизвестная ошибка при получении гео-данных.';
          }
          
          // Принудительно снимаем галочку с чекбокса во внутреннем UI, 
          // так как Vuex-экшен из-за ошибки уже вызвал disableTracking
          // event.target.checked = false;
        }
      } else {
        this.disableTracking();
      }
    },
    updatePrivacySettingClick() {
      this.updateUserPrivacySaveLoader = true;
      this.$http.post(`${this.$host.UserServiceApi}/UpdatePrivacySetting`, this.userData.userPrivacy)
      .then((response) => {
        this.userData.userPrivacy = response.body;
        this.updateUserPrivacySaveLoader = false;
      })
      .catch((e) => {
        this.updateUserPrivacySaveLoader = false;
      })
    },
    updateNotificationSettingClick() {
      this.updateNotificationSettingSaveLoader = true;
      this.$http.post(`${this.$host.UserServiceApi}/UpdateNotificationSetting`, this.userData.notificationSetting)
      .then((response) => {
        this.userData.notificationSetting = response.body;
        this.updateNotificationSettingSaveLoader = false;
      })
      .catch((e) => {
        this.updateNotificationSettingSaveLoader = false;
      })
    },
    showQrCodeClick() {
      // расчитываем оптимальный размер области QR кода
      const windowWidth = window.innerWidth;

      if (this.$store.state.onMobile) {
        // 1. Получаем базовый размер шрифта (1rem) в пикселях из тега html
        const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
        // 2. Считаем размер по вашей формуле: 100vw (windowWidth) минус 4rem и минут 12*2 padding
        const calculatedSize = windowWidth - (4 * rootFontSize) - (12 * 2);
        // Округляем до целого числа, чтобы canvas не размывался
        this.qrCodeSize = Math.round(calculatedSize);
      } else {
        this.qrCodeSize = 250; // Стандартный размер для десктопа
      }

      this.$refs.qrCodeDialogue.show({
        title: 'QR код вашего профиля',
        htmlContent: null,
        content: null,
        cancelButton: null
      })
    },
    showChangePasswordDlg() {
      this.$refs.changePasswordDialogue.show({
        title: 'Смена пароля',
        htmlContent: null,
        content: null,
        cancelButton: "Отмена"
      });
    },
    closeChangePasswordDialogue() {
      this.$refs.changePasswordDialogue.close();
    },
    loadProfileData() {
      this.userDataLoader = true;
      this.userData = null;
      this.$http.get(`${this.$host.UserServiceApi}`)
      .then((response) => {
        this.userData = response.body;
        this.userDataLoader = false;
      })
      .catch((e) => {
        this.userDataLoader = false;
      })
    },
    loadUserProfileVisibilityTypes() {
      this.userProfileVisibilityTypesLoader = true;
      this.$http.get(`${this.$host.UserServiceApi}/GetUserProfileVisibilityTypes`)
      .then((response) => {
        this.userProfileVisibilityTypes = response.body;
        this.userProfileVisibilityTypesLoader = false;
      })
      .catch((e) => {
        this.userProfileVisibilityTypesLoader = false;
      })
    },
    loadDateOfBirthVisibilityTypes() {
      this.dateOfBirthVisibilityTypesLoader = true;
      this.$http.get(`${this.$host.UserServiceApi}/GetDateOfBirthVisibilityTypes`)
      .then((response) => {
        this.dateOfBirthVisibilityTypes = response.body;
        this.dateOfBirthVisibilityTypesLoader = false;
      })
      .catch((e) => {
        this.dateOfBirthVisibilityTypesLoader = false;
      })
    },
    // loadTags() {
    //   // загружаем список всех тегов
    //   this.tagsLoader = true;
    //   this.tags = [];
    //   this.$http.get(`${this.$host.TagsServiceApi}`)
    //   .then((response) => {
    //     this.tags = response.body;
    //     this.tagsLoader = false;
    //   })
    //   .catch((e) => {
    //     this.tagsLoader = false;
    //   })
    // },
    // loadUserTags() {
    //   // пользовательские интересы это НЕ ТОЖЕ САМОЕ,
    //   // что теги событий!!!
    //   // пока отключил загрузку
    //   return;

    //   // загружаем список пользовательских тегов
    //   this.userTagsLoader = true;
    //   this.userTags = null;
    //   this.$http.get(`${this.$host.UserTagsServiceApi}/GetUserProfileTags`)
    //   .then((response) => {
    //     this.userTags = response.body;
    //     this.userTagsLoader = false;
    //   })
    //   .catch((e) => {
    //     this.userTagsLoader = false;
    //   })
    // },
    // updateUserTags() {
    //   this.userTagsSaveLoader = true;
    //   const payload = {
    //     tagIdList: this.userTags.enabledTags
    //   };
    //   this.$http.post(`${this.$host.UserTagsServiceApi}/SetUserProfileTags`, payload)
    //   .then((response) => {
    //     this.userTagsChanged = false;
    //     this.userTagsSaveLoader = false;
    //   })
    //   .catch((e) => {
    //     this.userTagsSaveLoader = false;
    //   })
    // },
    updateAvatar(newPhotoData) {
      // this.userAvatar = newPhotoData; // быстрый тест отображения
      // console.log('Новая аватарка получена родительским компонентом:', newPhotoData);
      // 1. Превращаем Base64-строку в честный бинарный Blob
      const blob = this.dataURLtoBlob(newPhotoData);
      const formData = new FormData();
        
      // Ключ 'file' должен СТРОГО совпадать с именем параметра 
      // в вашем C# контроллере: UploadUserAvatar(IFormFile file)
      formData.append('file', blob, 'avatar.png');
      this.$http.post(`${this.$host.AvatarsServiceApi}/UploadUserAvatar`, formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
          }
      })
      .then(() => {
        this.loadProfileData();
        this.$root.$emit('profile-changed');
      })
      .catch(() => { });
    },
    // Конвертирует строку "data:image/png;base64,..." в бинарный Blob
    dataURLtoBlob(dataUrl) {
      const arr = dataUrl.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      
      return new Blob([u8arr], { type: mime });
    },
    async deleteAvatarClick() {
      const isConfirmed = await this.$refs.confirmationDialogue.show({
        title: 'Подтвердите действие',
        message: 'Удалить автарку?',
        confirmButtonText: 'Да',
        cancelButtonText: 'Отмена'
      });
      if (isConfirmed) {
        await this.$http.post(`${this.$host.AvatarsServiceApi}/DeleteUserAvatar`)
        .then(() => {
          this.loadProfileData();
          this.$root.$emit('profile-changed');
        })
          .catch(() => { });
        }
    }
  },
  created() {
    this.loadUserProfileVisibilityTypes();
    this.loadDateOfBirthVisibilityTypes();
    this.loadProfileData();
    // this.loadTags();
    // this.loadUserTags();
  }
}
</script>

<style src='@/assets/css/user-profile.css'>
</style>
